__turbopack_context__.v({
  "loading-mochi": "index-module-scss-module__8xPZNa__loading-mochi",
  "show": "index-module-scss-module__8xPZNa__show",
});
